
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import VueSlider from "vue-slider-component";

@Component
export default class Products extends Vue {
  sliderValue = 8;
  sliderValue2 = 3;
  sliderValue3 = 4;
  sliderOptions = {
    dotSize: 6,
    width: "auto",
    height: 6,
    contained: false,
    direction: "ltr",
    data: null,
    dataLabel: "label",
    dataValue: "value",
    min: 0,
    max: 15,
    interval: 1,
    disabled: false,
    clickable: true,
    duration: 0.5,
    adsorb: false,
    lazy: false,
    tooltip: "none",
    tooltipPlacement: "top",
    tooltipFormatter: void 0,
    useKeyboard: false,
    keydownHook: null,
    dragOnClick: false,
    enableCross: true,
    fixed: false,
    minRange: void 0,
    maxRange: void 0,
    order: true,
    marks: false,
    dotOptions: void 0,
    dotAttrs: void 0,
    process: true,
    dotStyle: { backgroundColor: "transparent !important", border: "2px solid transparent !important" },
    railStyle: void 0,
    processStyle: { backgroundColor: "#ff699b" },
    tooltipStyle: void 0,
    stepStyle: void 0,
    stepActiveStyle: void 0,
    labelStyle: void 0,
    labelActiveStyle: void 0,
  };
}
